import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Wallet, Users, Activity, User } from 'lucide-react';

const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/wallet', icon: Wallet, label: 'Wallet' },
    { path: '/ajo', icon: Users, label: 'Ajo' },
    { path: '/activity', icon: Activity, label: 'Activity' },
    { path: '/profile', icon: User, label: 'Profile' },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="bottom-nav" data-testid="bottom-nav" style={{ background: 'rgba(15, 31, 92, 0.95)' }}>
      {navItems.map((item) => (
        <button
          key={item.path}
          onClick={() => navigate(item.path)}
          data-testid={`nav-${item.label.toLowerCase()}`}
          className={`flex flex-col items-center gap-1 p-2 rounded-full transition-all touch-btn ${
            isActive(item.path)
              ? 'bg-white/20 text-white'
              : 'text-white/60 hover:text-white/80'
          }`}
        >
          <item.icon size={20} strokeWidth={isActive(item.path) ? 2.5 : 1.5} />
          <span className="text-[10px] font-medium">{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default BottomNav;
